<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OmRaKS/images/cover.jpg?1730635551040" alt="This image is the cover for the book Big Book of Words You Should Know"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Big Book of Words You Should Know
      </h1>
      <p class="bookDescription body article font2">
        <b>Do you know what "quatrefoil" and "impolitic" mean? What about "halcyon" or "narcolepsy"?<br/><br/>This book is a handy, easy-to-read reference guide to the proper parlance for any situation.</b> In this book you will find: Words You Absolutely Should Know (covert, exonerate, perimeter); Words You Should Know But Probably Don't (dour, incendiary, scintilla); Words Most People Don't Know (schlimazel, thaumaturgy, epergne); Words You Should Know to Sound Overeducated (ad infinitum, nugatory, garrulity); Words You Probably Shouldn't Know (priapic, damnatory, labia majora); and more.<br/><br/>Whether writing an essay, studying for a test, or trying to impress friends, family, and fellow cocktail party guests with their prolixity, you will achieve magniloquence, ebullience, and flights of rhetorical brilliance.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Olsen, Michelle Bevilacqua, Justin Cord Hayes
      </h2>
      
      <p class="authorDescription body article">An Adams Media author.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?256bff21